import { render, staticRenderFns } from "./question.vue?vue&type=template&id=0172ce50&scoped=true"
import script from "./question.vue?vue&type=script&lang=ts"
export * from "./question.vue?vue&type=script&lang=ts"
import style0 from "./question.vue?vue&type=style&index=0&id=0172ce50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0172ce50",
  null
  
)

export default component.exports